export const CAR_TABLE = [
    [null, null, null, null, null],
    [null, null, null, null, null],
    [null, null, null, null, null]    
];

export const CAP_S_CAPITAL_TABLE = [
    ["CET1", 0, null, null, null, null, null, null, null, null, null],
    ["CET1Deduct", 0, null, null, null, null, null, null, null, null, null],
    ["AT1", 0, null, null, null, null, null, null, null, null, null],
    ["AT1Deduct", 0, null, null, null, null, null, null, null, null, null],
    ["Tier 2", 0, null, null, null, null, null, null, null, null, null],
    ["Tier 2 Deduct", 0, null, null, null, null, null, null, null, null, null],
    ["Total", 0, "Total", null, null, null, null, null, null, null, null]
];

export const CAP_C_CAPITAL_TABLE = [
    ["CET1", 0, null, null, null, null, null, null, null, null, null],
    ["CET1Deduct", 0, null, null, null, null, null, null, null, null, null],
    ["AT1", 0, null, null, null, null, null, null, null, null, null],
    ["AT1Deduct", 0, null, null, null, null, null, null, null, null, null],
    ["Tier 2", 0, null, null, null, null, null, null, null, null, null],
    ["Tier 2 Deduct", 0, null, null, null, null, null, null, null, null, null],
    ["Total", 0, "Total", null, null, null, null, null, null, null, null]
];

export const CAP_S_RWA_TABLE_TOP = [
    ["Sovereign exposures", 0, null, 0, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
    ["Financial Institution exposures", 0, null, 0, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
    ["Corporate exposures", 0, null, 0, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
    ["Retail exposures", 0, null, 0, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
    ["Defaulted exposures", 0, null, 0, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
    ["Other assets", 0, null, 0, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
    ["Real estate exposures", 0, null, 0, null, null, null, null, null, null, null, null, null, null, null, null, null, null]
];

export const CAP_S_RWA_TABLE_BOTTOM = [
    ["CCR", null, null, 0, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
    ["CVA", 0, null, 0, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
    ["Operational Risk", null, null, 0, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
    ["Market risk", null, null, 0, null, null, null, null, null, null, null, null, null, null, null, null, null, null]
];

export const CAP_C_RWA_TABLE_TOP = [
    ["Sovereign exposures", 0, null, 0, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
    ["Financial Institution exposures", 0, null, 0, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
    ["Corporate exposures", 0, null, 0, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
    ["Retail exposures", 0, null, 0, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
    ["Defaulted exposures", 0, null, 0, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
    ["Other assets", 0, null, 0, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
    ["Real estate exposures", 0, null, 0, null, null, null, null, null, null, null, null, null, null, null, null, null, null]
];

export const CAP_C_RWA_TABLE_BOTTOM = [
    ["CCR", null, null, 0, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
    ["CVA", null, null, 0, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
    ["Operational Risk", null, null, 0, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
    ["Market risk", null, null, 0, null, null, null, null, null, null, null, null, null, null, null, null, null, null]
];


// WEBPACK FOOTER //
// ./src/pages/CapitalPlanning/Dashboard/constants.js